import { useQuery } from '@tanstack/react-query';
import React from 'react';

import { Team } from '@/types';

import { fetchTeamBadges } from '../api/getTeamBadges';

interface TeamBadgesProps {
  teamData: Team;
}
const TeamBadges: React.FC<TeamBadgesProps> = ({ teamData }) => {
  const { data: badges } = useQuery({
    queryKey: ['badge', teamData.id],
    queryFn: () => fetchTeamBadges(teamData.id?.toString()),
    enabled: !!teamData.id?.toString(),
  });

  if (!teamData.id) return <div>Id undefined</div>;

  if (!badges) return null;

  return (
    <div className="mr-auto hidden max-w-full gap-x-1.5 lg:flex">
      {badges.map((badge, index) => (
        <img
          key={index}
          alt={`Badge ${index}`}
          title={badge.description}
          className={`mr-2 inline-block h-10 transition-transform hover:scale-150`}
          src={` /images/${badge.image_src}`}
        />
      ))}
    </div>
  );
};

export { TeamBadges };
